<template>
    <transition name="fade">
        <div class="popup-modal" v-if="isVisible">
            <div class="window" :class="size">
                <slot></slot>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: 'PopupModal',

    props: {
        size: {
            type: String,
            default: ''
        }
    },

    data: () => ({
        isVisible: false,
    }),

    methods: {
        open() {
            this.isVisible = true
        },

        close() {
            this.isVisible = false
        },
    },
}
</script>

<style lang="css" scoped src='../assets/css/popup-modal.css'>
</style>